<template>
  <div class="notifications-page">
    <div class="notifications-view">
      <div v-if="!imagePreview" class="upload-container">
        <div
          class="drop-zone"
          @dragover.prevent
          @drop.prevent="handleDrop"
        >
          <v-icon class="upload-icon">cloud_upload</v-icon>
          <p>select your file or drag and drop</p>
          <p class="accepted-types">jpg, png, jpeg accepted</p>
          <label for="file-upload" class="custom-file-upload">
            browse
          </label>
          <input id="file-upload" type="file" @change="handleFileUpload" />
        </div>
      </div>
      <div v-if="imagePreview" class="image-preview">
        <h3>Image Preview:</h3>
        <div class="image-container">
          <img :src="imagePreview" alt="Selected Image" />
          <button class="close-button" @click="cancelImage">X</button>
        </div>
        <div class="input-container">
          <input v-model="title" type="text" placeholder="Enter title" class="title-input" />
          <textarea v-model="body" placeholder="Enter body" class="body-textarea"></textarea>
        </div>
        <div>
          <button class="send-button" @click="uploadImage">Send</button>
        </div>
      </div>
    </div>
    <div class="notification-history-container">
      <NotificationHistory />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import NotificationHistory from '@/components/NotificationHistory.vue';

export default {
  name: "NotificationsView",
  components: {
    NotificationHistory,
  },
  data() {
    return {
      imagePreview: null,
      selectedFile: null,
      title: "",
      body: ""
    };
  },
  methods: {
    ...mapActions('notifications', ['sendNotification']),

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
        this.readFile(file);
      }
    },
    handleDrop(event) {
      const file = event.dataTransfer.files[0];
      if (file) {
        this.selectedFile = file;
        this.readFile(file);
      }
    },
    readFile(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
        this.title = ""; // Reset title
        this.body = ""; // Reset body
      };
      reader.readAsDataURL(file);
    },
    cancelImage() {
      this.imagePreview = null;
      this.selectedFile = null;
    },
    async uploadImage() {
      if (!this.selectedFile) {
        alert('No file selected!');
        return;
      }

      const formData = new FormData();
      formData.append('file', this.selectedFile);

      try {
        const response = await this.sendNotification({
          formData,
          title: this.title,
          body: this.body,
        });
        console.log('Upload successful:', response);
        this.cancelImage();
      } catch (error) {
        console.error('Error uploading image:', error);
      }
    },
  },
};
</script>

<style scoped>
.notifications-page {
  display: flex;
  justify-content: space-between;
  padding: 30px;
}
.notifications-view {
  flex: 2;
  text-align: center;
  margin-right: 20px;
}
.notification-history-container {
  flex: 1;
}

.upload-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.drop-zone {
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Add spacing */
  align-items: center;
  border: 2px dashed #ccc;
  border-radius: 10px;
  padding: 40px; /* Increase padding */
  text-align: center;
  width: 500px; /* Increase width */
  height: 300px; /* Increase height */
  margin-bottom: 20px;
}

.upload-icon {
  font-size: 50px;
  color: #0434a0;
}

.custom-file-upload {
  display: inline-block;
  background-color: #0434a0;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
}

.custom-file-upload:hover {
  background-color: #032b7a;
}

input[type="file"] {
  display: none;
}

.accepted-types {
  font-size: 12px;
  color: #666;
}

.image-preview {
  position: relative;
  margin-top: 20px;
}

.image-container {
  position: relative;
  display: inline-block;
}

.image-preview img{
  max-width: 500px; /* Increase max width */
  max-height: 500px; /* Increase max height */
  border: 1px solid #ccc;
  border-radius: 5px;
}

.close-button {
  position: absolute;
  top: 5px; /* Position at the top of the img element */
  right: 5px; /* Position at the right of the img element */
  background-color: red;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 16px;
  font-weight: bold; /* Make the X bold */
  cursor: pointer;
  z-index: 10; /* Ensure the button is in front */
}

.close-button:hover {
  background-color: darkred;
}

.send-button {
  margin-top: 30px;
  background-color: #0434a0;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 20px;
}

.send-button:hover {
  background-color: #032b7a;
}

.input-container {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title-input {
  width: 40%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.body-textarea {
  width: 40%;
  height: 100px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  resize: none;
}
</style>